// extracted by mini-css-extract-plugin
export var adjacentSlide = "_lj-9";
export var arrowButtonContainer = "_lj-5";
export var arrowButtonIcon = "_lj-6";
export var carouselArrowButton = "_lj-2";
export var carouselElementContainer = "_lj-1";
export var currentSlide = "_lj-8";
export var left = "_lj-3";
export var otherSlide = "_lj-a";
export var productCarouselContainer = "_lj-0";
export var right = "_lj-4";
export var sliderOverflow = "_lj-7";